// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { Link } from 'react-router-dom';
import "../style/navbar.css";
import logo from "../parm_assets/parm_logo_neww.png"; // update path if different
// import AboutHero from "./about_us/AboutUs_page";

// Simplified navigation items - no dropdown arrays needed
const navItems = [
  { name: 'HOME', link: '/' },
  { name: 'ABOUT US', link: '/about-parm' },
  // { name: 'SERVICES', link: '/services-parm' },
  // { name: 'CEU', link: '' },
  { name: 'EVENTS', link: '/events-parm' },
  { name: 'INTAC 2026', link: '/intac2026-parm' },
  // { name: 'TCC', link: '' },
  { name: 'NEWS', link: '/news-parm' },
  { name: 'ARBORICA', link: '/arborica-all-parm' },
];

const Navbar = () => {
  // Use state only for the mobile menu toggle
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Listen for auth changes
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo and PArM Text */}
        <div className="navbar-logo-container">
          <Link to="/" className="explore-btn-new-page">
            <img src={logo} alt="icon" className="navbar-parm-logo" />
          </Link>
        </div>

        {/* Hamburger Icon for Mobile */}
        <div className="menu-icon" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? '✕' : '☰'}
        </div>

        {/* Main Navigation Links */}
        <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <div key={item.name} className="nav-item">
              <Link to={item.link} className="nav-links" onClick={() => setIsMobileMenuOpen(false)}>
                {item.name}
              </Link>
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="navbar-buttons">
          {user ? (
            <Link to="/member-dashboard-parm">
              <button className="btn sign-in">Dashboard</button>
            </Link>
          ) : (
            <Link to="/login-parm">
              <button className="btn sign-in">Sign In</button>
            </Link>
          )}

          <Link to="/membership-parm">
            <button className="btn membership">
              Membership <span className="arrow-right">→</span>
            </button>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
